<template>
  <PageTemplate>
    <v-breadcrumbs
      :breadcrumbs="breadcrumbs"
    />
    <h1>News</h1>
    <v-card title="Latest News">
      <div class="news-page__body">
        <v-spinner v-if="newsLoading" />
        <v-table
          :table="news"
          :show-row-count="true"
          :show-clear-filters="false"
        />
      </div>
    </v-card>
  </PageTemplate>
</template>

<script>
  import PageTemplate from "../templates/Page/index.vue";
  import Breadcrumbs from "@/molecules/Breadcrumbs";
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import Spinner from "@/atoms/Spinner";
  import {columnSort, dateSort_ddmmyyyy, buildBreadCrumb} from "../common/tableFunctions";
  import {GET_NEWS} from "../store/actions.type";
  import routes from "@/common/routes";

  export default {
    name: "News",
    components: {
      "v-table": Table,
      "v-breadcrumbs": Breadcrumbs,
      "v-card": Card,
      "v-spinner": Spinner,
      PageTemplate,
    },
    data() {
      return {
        news: {
          columns: [
            {
              label: 'Title',
              field: 'title',
              sortFn: columnSort,
              thClass: 'sortable',
              link: true
            },
            {
              label: 'Category',
              field: 'category',
              sortFn: columnSort,
              thClass: 'sortable'
            },
            {
              label: 'Date',
              field: 'date',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable'
            }
          ],
          rows: []
        },
        breadcrumbs: [],
      };
    },
    computed: {
      newsRow() {
        return this.$store.state.news.news;
      },
      newsLoading() {
        return this.$store.state.news.loading;
      }
    },
    watch: {
      newsRow: {
        handler(val) {
          if (val && Array.isArray(val)) {
            this.news.rows = val.slice(0, 15);
          } else {
            this.news.rows = [];
          }
        },
        immediate: true
      }
    },
    mounted() {
      this.getNews();
      this.updateBreadCrumb();
    },
    methods: {
      updateBreadCrumb() {
        const breadcrumbs = {};
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['News'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getNews() {
        this.$store.dispatch(GET_NEWS, { limit: 15 });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .news-page__body {
    position: relative;
    min-height: 160px;
  }
</style>
